import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgRuzie = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="M10 28a4 4 0 0 1 4 4v4H6v-4a4 4 0 0 1 4-4"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      d="M10 28a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="M30 28a4 4 0 0 1 4 4v4h-8v-4a4 4 0 0 1 4-4"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      d="M30 28a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
    <path
      fill="#FF7842"
      d="m23.24 25.72-3.12-1.92-3.05 2.02-1.68-3.25-3.66.18.36-3.63-3.14-2.89 2.79-3.28-.61-4.26 4.18-.95 2.22-3.68 3.66 2.2 4.12-1.08 1.3 4.07 3.89 1.77-1.66 3.92 2.03 2.86-3.17 1.48.38 3.47-3.49-.26z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m16.05 3.874 3.907 2.349 3.916-1.027.254.968-4.324 1.133-3.413-2.051-2.072 3.434-3.938.895.545 3.804-.99.142-.675-4.716L13.682 7.8z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M18.41 8.25h3.18l-.54 8.87H19zM20 21.92a1.55 1.55 0 0 1-1.14-.47 1.53 1.53 0 0 1-.47-1.12 1.55 1.55 0 0 1 .48-1.15 1.57 1.57 0 0 1 2.26 0 1.55 1.55 0 0 1 .48 1.15 1.53 1.53 0 0 1-.47 1.12 1.55 1.55 0 0 1-1.14.47"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M12 25.63a1.5 1.5 0 0 0-1.5 1.5h-1a2.5 2.5 0 0 1 5 0h-1a1.5 1.5 0 0 0-1.5-1.5M28 25.63a1.5 1.5 0 0 0-1.5 1.5h-1a2.5 2.5 0 0 1 5 0h-1a1.5 1.5 0 0 0-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgRuzie);

export default ForwardRef;
